"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  cancelText: 'Cancel',
  okText: 'OK',
  title: 'please select'
};
exports.default = _default;